/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type ExternalAgentMatchingStatus =
  (typeof ExternalAgentMatchingStatus)[keyof typeof ExternalAgentMatchingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAgentMatchingStatus = {
  idle: 'idle',
  pending: 'pending',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
} as const;
